const { marked } = require("marked");
const { toHTML } = require("@portabletext/to-html");

export const decodeHTMLEntities = (text) => {
  const txt = document.createElement("textarea");
  txt.innerHTML = text;
  return txt.value;
}
export const encodeHTMLEntities = (html) => {
  const txt = document.createElement("textarea");
  txt.textContent = html;
  return txt.innerHTML;
}

// For handling marks from Sanity Portable Text while also processing Markdown
export const processText = (text, blocks) => {
  let result = text || '';

  if (Array.isArray(blocks) && blocks.length > 0) {
    result = toHTML(blocks, {
      components: {
        types: {
          undefined: ({ children }) => children ? `<p>${children}</p>` : '',
        },
        block: {
          normal: ({ children }) => `${children}`,
          default: ({ children }) => `${children}`
        },
        marks: {
          strong: ({children}) => `<strong>${children}</strong>`,
          em: ({children}) => `<em>${children}</em>`,
          underline: ({children}) => `<u>${children}</u>`
        }
      }
    });
  }

  result = marked.parseInline(result);
  return result;
};

/**
 * The below fields (not parentType) are derived from imageWithCaption schema in sanity studio
 * - image: { asset: { _ref: string } }
 * - caption: [{ children: [{ text: string }] }]
 * - fullCaption: [{ children: [{ text: string }] }]
 * - parentType: string identifying the parent content block type i.e textWithImage, imageWithCaption.
 *
 * Warnings being logged to the console should only occur when a page is being viewed in preview mode and a required field has not yet been provided.
 */
export class ImageWithCaptionModel {
  constructor(image, caption, fullCaption, parentType) {
    this.image = image;
    this.caption = caption;
    this.fullCaption = fullCaption;
    this.parentType = parentType;
  }

  imageUrl() {
    if (!this.image?.asset?._ref) return '';

    const [fileType, extension] = this.getExtension(this.image.asset._ref);
    const projectId = window?.MoMA?.appInfo?.sanityProjectID || "";
    const dataset = window?.MoMA?.appInfo?.sanityDataset || "";

    return `https://cdn.sanity.io/images/${projectId}/${dataset}/${this.image.asset._ref
      .replace('image-', '')
      .replace(`-${fileType}`, extension)}?auto=format`;
  }

  captionText() {
    if (!this.caption) return '';
    return this.caption[0]?.children[0]?.text || '';
  }

  fullCaptionText() {
    if (!this.fullCaption) return '';
    return this.fullCaption[0]?.children[0]?.text || '';
  }

  getExtension(ref) {
    const extensions = {
      'jpg': '.jpg',
      'png': '.png',
      'gif': '.gif'
    };

    for (const [key, value] of Object.entries(extensions)) {
      if (ref.endsWith(`-${key}`)) {
        return [key, value];
      }
    }
    return ['jpg', '.jpg']; // default fallback
  }
}